import { useTranslation } from 'react-i18next';
import { FaUserCircle } from 'react-icons/fa';
import { FiMenu } from 'react-icons/fi';

import {
  Flex,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

import { useAuth } from '@/context/useAuth';
import LogoutConfirmationDialog from '@/components/Modals/LogoutConfirmationDialog';
import { useTrimmedFullName } from '@/utils/useTrimmedFullName';
import { MobileProps } from '@/interfaces/Interfaces';

const Header = ({ onOpen, ...rest }: MobileProps) => {
  const { logout, organizationName, fullName } = useAuth();
  const { t } = useTranslation();
  const trimmedFullName = useTrimmedFullName(fullName);
  const {
    isOpen: isLogoutDialogOpen,
    onOpen: onLogoutDialogOpen,
    onClose: onLogoutDialogClose,
  } = useDisclosure();

  const headerText = organizationName
    ? `${organizationName} 管理者用`
    : '管理者用ダッシュボード';

  return (
    <Flex
      px={{ base: 4, md: 4 }}
      height="20"
      alignItems="center"
      bg="white"
      borderBottomWidth="1px"
      borderBottomColor="gray.200"
      justifyContent="space-between"
      {...rest}
    >
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />

      <Text
        display="flex"
        fontSize={{ base: 'xl', md: '2xl' }}
        fontWeight="bold"
      >
        {headerText}
      </Text>

      <HStack spacing={{ base: '0', md: '6' }}>
        <Text
          fontSize={{ base: 'sm', md: 'lg', lg: 'xl' }}
          fontWeight={'semibold'}
          display={{ base: 'none', md: 'block' }}
          title={`${t('welcome')} ${fullName} さん`}
        >
          {`${t('welcome')} ${trimmedFullName} さん`}
        </Text>
        {/* <IconButton
          size="lg"
          variant="ghost"
          aria-label="open menu"
          icon={<FiBell size={25} />}
        /> */}
        <Flex alignItems={'center'}>
          <Menu>
            <MenuButton
              transition="all 0.3s"
              _focus={{ boxShadow: 'none' }}
              _hover={{ opacity: 0.7 }}
            >
              <HStack>
                <FaUserCircle size={30} />
              </HStack>
            </MenuButton>
            <MenuList mt={2} bg="white" borderColor="gray.200">
              {/* <MenuItem
                _focus={{ boxShadow: 'none' }}
                _hover={{
                  bg: 'teal',
                  color: 'white',
                }}
              >
                {t('profile-button')}
              </MenuItem> */}
              {/* <MenuItem
                _hover={{
                  bg: 'teal',
                  color: 'white',
                }}
              >
                設定
              </MenuItem> */}
              <MenuDivider />
              <MenuItem
                _focus={{ boxShadow: 'none' }}
                _hover={{
                  bg: 'teal',
                  color: 'white',
                }}
                onClick={onLogoutDialogOpen}
              >
                {t('logout-button')}
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
      <LogoutConfirmationDialog
        isOpen={isLogoutDialogOpen}
        onClose={onLogoutDialogClose}
        onConfirm={() => {
          onLogoutDialogClose();
          logout();
        }}
      />
    </Flex>
  );
};

export default Header;
